import {
  GridCellParams,
  GridColDef,
  GridRenderCellParams,
  GridValueFormatterParams,
  GridValueGetterParams,
  GridValueSetterParams
} from '@mui/x-data-grid-pro';

import {COLUMN_TYPE_ACTIONS} from '@utils/table/columnTypes/actions.columnType';
import {COLUMN_TYPE_TEXT, COLUMN_TYPE_TEXT_BOLD} from '@utils/table/columnTypes/text.columnType';
import {COLUMN_TYPE_TEXT_WITH_ACTION} from '@utils/table/columnTypes/textWithAction.columnType';
import {COLUMN_TYPE_SELECT} from '@utils/table/columnTypes/select.columnType';
import {COLUMN_TYPE_NUMBER} from '@utils/table/columnTypes/number.columnType';
import {COLUMN_TYPE_ICONS} from '@utils/table/columnTypes/icons.columnType';
import {COLUMN_TYPE_INPUT} from '@utils/table/columnTypes/input.columnType';
import {COLUMN_TYPE_DATE} from '@utils/table/columnTypes/date.columnType';
import {COLUMN_TYPE_ICON} from '@utils/table/columnTypes/icon.columnType';
import {COLUMN_TYPE_ASYNC_SELECT} from '@utils/table/columnTypes/asyncSelect.columnType';
import {COLUMN_TYPE_CHECKS} from '@utils/table/columnTypes/checks.columnType';
import {COLUMN_TYPE_CUSTOM} from '@utils/table/columnTypes/custom.columnType';
import {ReactElement} from 'react';
import {COLUMN_TYPE_MULTI_INPUT} from '@utils/table/columnTypes/multiInput.columnType';

export interface ColumnProps {
  cellClassName?: (props: GridCellParams) => string;
  color?: string;
  field?: string;
  label?: string;
  fullWidth?: boolean;
  minWidth?: number;
  sortable?: boolean;
  valueGetter?: (props: GridValueGetterParams) => string | number;
  valueFormatter?: (props: GridValueFormatterParams) => string;
  valueSetter?: (props: GridValueSetterParams) => string | number;
  width?: number;
  editable?: boolean;
  renderCell: (props: GridRenderCellParams) => ReactElement;
}

interface ColumnTypes {
  [key: string]: (props: any) => GridColDef;
}

function getColumnTypes<T extends { [keyName: string]: (props: any) => GridColDef }>(types: T) {
  return types;
}

const COLUMN_TYPES: ColumnTypes = getColumnTypes({
  TEXT: COLUMN_TYPE_TEXT,
  CUSTOM: COLUMN_TYPE_CUSTOM,
  TEXT_BOLD: COLUMN_TYPE_TEXT_BOLD,
  TEXT_WITH_ACTION: COLUMN_TYPE_TEXT_WITH_ACTION,
  ICONS: COLUMN_TYPE_ICONS,
  ICON: COLUMN_TYPE_ICON,
  SELECT: COLUMN_TYPE_SELECT,
  ASYNC_SELECT: COLUMN_TYPE_ASYNC_SELECT,
  NUMBER: COLUMN_TYPE_NUMBER,
  INPUT: COLUMN_TYPE_INPUT,
  DATE: COLUMN_TYPE_DATE,
  CHECKS: COLUMN_TYPE_CHECKS,
  ACTIONS: COLUMN_TYPE_ACTIONS,
  MULTI_INPUT: COLUMN_TYPE_MULTI_INPUT,
});

export default COLUMN_TYPES;
